import { IProject } from "@droid/project-v2-interface"

export const projectUtils = {
    getProjectName: (project?: IProject):string => {
        return project?.localName || project?.name || project?.ulid?.slice(project?.ulid?.length - 8) || ''
    }
}

